import { apiFetch } from "../utils/api";

export const complaintsService = {

  async create(data) {
    return apiFetch('/api/complaints', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  },

  async update(id, data) {
    return apiFetch(`/api/complaints/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  },

  async resolve(id, observations) {
    return apiFetch(`/api/complaints/${id}/resolve`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ observations })
    });
  },

  async reopen(id) {
    return apiFetch(`/api/complaints/${id}/reopen`, {
      method: 'POST'
    });
  }

};
